import { create } from 'zustand';

type SsoRedirectStore = {
  isRedirecting: boolean;
  message: string;
  start: (message: string) => void;
};

export const useSsoRedirectStore = create<SsoRedirectStore>((set) => ({
  isRedirecting: false,
  message: '',
  start: (message) => set({ isRedirecting: true, message }),
}));
